import { render } from "./comentarioList.vue?vue&type=template&id=8b93302c"
import script from "./comentarioList.vue?vue&type=script&lang=js"
export * from "./comentarioList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__